import { render, staticRenderFns } from "./templateVendorUpdate.vue?vue&type=template&id=1b486c95"
import script from "./templateVendorUpdate.vue?vue&type=script&lang=js"
export * from "./templateVendorUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports